<b-col cols="12" sm="12" md="4" lg="4" xl="4"></b-col>
<template>
    <b-modal title="Edit Pianificazione" ref="mdlRsaAreaPianificazioneEdit" id="mdlRsaAreaPianificazioneEdit" size="lg"
        :okDisabled="disabeConferma" @ok="onOk" @shown="onShown">
        <div class="sa-tab-scroll">
            <!-- <div class="sa-flexbox-pianificazione-modal"> -->
            <div class="sa-flexbox-pianificazione-modal-header">
                <div>
                    <b-row>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Data Inizio:</label>
                            <b-input-group class="mb-3">
                                <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="jsonData.dataInizio"
                                    type="search"></date-picker>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Data Fine:</label>
                            <b-input-group class="mb-3">
                                <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="jsonData.dataFine"
                                    type="search"></date-picker>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Attività:</label>
                            <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.nomeAttivita"
                                value-field="codice" text-field="nomeAttivita" value="null" class="mb-2 mr-sm-2 mb-sm-0"
                                :options="attivitaOptions" @change="onChangeAttivita"></b-form-select>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="sa-flexbox-pianificazione-modal-body">
                <div
                    style="flex: 1; height: 100%; background-color: transparent; overflow: hidden; display: flex; flex-direction: column">
                    <label class="sa-label-data">Indicazioni:</label>
                    <vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.indicazioni" />
                </div>
                <!-- <div style="height: 100%; background-color: transparent; overflow: hidden">
					<label class="sa-label-data">Indicazioni:</label>
					<vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.indicazioni" />
				</div> -->
            </div>
            <div class="sa-flexbox-pianificazione-modal-footer">
                <div style="display: block; background-color: transparent">
                    <b-tabs id="tabsRsaAree" ref="tabsRsaAree" v-model="activeTabIndex" content-class="mt-3"
                        class="sa-tab" style="height: 100%" fill>
                        <b-tab title="Orario" :disabled="tabOrarioDisabled">
                            <rsa-pianificazione-edit-orario ref="cmpRsaPianificazioneEditOrario"
                                @afterMounted="onAfterMountedRsaPianificazioneEditOrario"
                                @updatePianificazioneOrario="onUpdatePianificazioneOrario"></rsa-pianificazione-edit-orario>
                        </b-tab>
                        <b-tab title="Turni" :disabled="tabTurniDisabled">
                            <rsa-pianificazione-edit-turni ref="cmpRsaPianificazioneEditTurni"
                                @afterMounted="onAfterMountedRsaPianificazioneEditTurni"
                                @updatePianificazioneTurni="onUpdatePianificazioneTurni"></rsa-pianificazione-edit-turni>
                        </b-tab>

                        <b-tab title="Ore Alternate" :disabled="tabOreAlternateDisabled">
                            <rsa-pianificazione-edit-ore-alternate ref="cmpRsaPianificazioneEditOreAlternate"
                                @afterMounted="onAfterMountedRsaPianificazioneEditOreAlternate"
                                @updatePianificazioneOreAlternate="onUpdatePianificazioneOreAlternate"></rsa-pianificazione-edit-ore-alternate>
                        </b-tab>
                        <b-tab title="Giorni Alternati" :disabled="tabGiorniAlternatiDisabled">
                            <rsa-pianificazione-edit-giorni-alternati ref="cmpRsaPianificazioneEditGiorniAlternati"
                                @afterMounted="onAfterMountedRsaPianificazioneEditGiorniAlternati"
                                @updatePianificazioneGiorniAlternati="onUpdatePianificazioneGiorniAlternati"></rsa-pianificazione-edit-giorni-alternati>
                        </b-tab>
                        <b-tab title="Giorni del Mese" :disabled="tabGiorniMeseDisabled">
                            <rsa-pianificazione-edit-giorni-mese ref="cmpRsaPianificazioneEditGiorniMese"
                                @afterMounted="onAfterMountedRsaPianificazioneEditGiorniMese"
                                @updatePianificazioneGiorniMese="onUpdatePianificazioneGiorniMese"></rsa-pianificazione-edit-giorni-mese>
                        </b-tab>
                        <b-tab title="Accessi" :disabled="tabAccessiDisabled">
                            <rsa-pianificazione-edit-accessi ref="cmpRsaPianificazioneEditAccessi"
                                @afterMounted="onAfterMountedRsaPianificazioneEditAccessi"
                                @updatePianificazioneAccessi="onUpdatePianificazioneAccessi"></rsa-pianificazione-edit-accessi>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
            <BancaFarmaciRicercaFarmacoComponent ref="cmpBancaFarmaciRicercaFarmacoComponent"
                @confermaSelezione="onConfermaSelezioneBancaFarmaciRicercaFarmacoComponent"
                @annullaSelezione="onAnnullaSelezioneBancaFarmaciRicercaFarmacoComponent">
            </BancaFarmaciRicercaFarmacoComponent>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { VueEditor } from "vue2-editor";
import RsaPianificazioneEditAccessi from "../../components/pianificazione/RsaPianificazioneEditAccessi.vue";
import RsaPianificazioneEditTurni from "../../components/pianificazione/RsaPianificazioneEditTurni.vue";
import RsaPianificazioneEditOrario from "../../components/pianificazione/RsaPianificazioneEditOrario.vue";
import RsaPianificazioneEditOreAlternate from "../../components/pianificazione/RsaPianificazioneEditOreAlternate.vue";
import RsaPianificazioneEditGiorniAlternati from "../../components/pianificazione/RsaPianificazioneEditGiorniAlternati.vue";
import RsaPianificazioneEditGiorniMese from "../../components/pianificazione/RsaPianificazioneEditGiorniMese.vue";
import BancaFarmaciRicercaFarmacoComponent from "../../../bancafarmaci/components/BancaFarmaciRicercaFarmacoComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
    mixins: [UtilityMixin],
    components: {
        DatePicker,
        VueEditor,
        RsaPianificazioneEditAccessi,
        RsaPianificazioneEditTurni,
        RsaPianificazioneEditOrario,
        RsaPianificazioneEditOreAlternate,
        RsaPianificazioneEditGiorniAlternati,
        RsaPianificazioneEditGiorniMese,
        BancaFarmaciRicercaFarmacoComponent,
    },
    created(activeTabIndex = null) {
        this.activeTabIndex = activeTabIndex != null ? activeTabIndex : 0;
    },
    data() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const minDate = new Date(today);
        return {
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
            tabOrarioDisabled: false,
            tabTurniDisabled: false,
            tabOreAlternateDisabled: false,
            tabGiorniAlternatiDisabled: false,
            tabGiorniMeseDisabled: false,
            tabAccessiDisabled: false,
            btnDisabledAggiungiOrario: false,
            disabeConferma: false,
            pathResource: "/rsaattivitapazienteschedulazioni",
            pathResourceAttivita: "/rsaattivita",
            pathResourcesPrescrizioni: "/rsapazienteprescrizioni",
            pathResourcePazientePrescrizioniFarmacologiche: "/rsapazienteprescrizioni",
            attivitaOptions: [{ codice: null, nomeAttivita: "-Seleziona Attività-" }],
            schedulazione: { dataInizio: null, orario: null },
            jsonData: { nomeAtivita: null, dataInizio: null, dataFine: null, indicazioni: null, listaOrari: [], idForm: "", params: null },
            listaOrari: [],
            prescrizione: {},
            riepilogo: { quantitaProgrammata: 0, quantitaSchedulata: 0 },
            min: minDate,
            orarioData: new Date(),
            activeTabIndex: 0,
            pianificazione: { dataInizio: null, giorni: null, orari: null, tipo: null, tipoData: null },
            attivitaItems: [],
            jsonDataParams: {},
            schedaFarmaco: {},
            doseFarmaco: null,
            unitaMisureOptions: [
                { text: "---", value: null },
                { text: "Unità", value: "UN" },
                { text: "Grammi", value: "GR" },
            ],
            jsonDataAccettazione: {},
            fields: [
                {
                    label: "Data",
                    key: "dataInizio",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                },
                {
                    label: "Ora",
                    key: "orario",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            perPage: 1000000,
        };
    },
    watch: {
        doseFarmaco(value) {
            this.jsonDataParams.dose = value;
        },
        // riepilogo: {
        // 	handler() {
        // 		let me = this;
        // 		me.btnDisabledAggiungiOrario = false;
        // 		console.log(me.schedulazione);
        // 		if (me.listaOrari.length === 1) {
        // 			me.jsonData.dataInizio = me.schedulazione.dataInizio;
        // 		}
        // 		if (me.listaOrari.length === me.prescrizione.quantitaAccessi) {
        // 			me.jsonData.dataFine = me.schedulazione.dataInizio;
        // 			me.btnDisabledAggiungiOrario = true;
        // 		}
        // 	},
        // 	deep: true,
        // },
    },
    methods: {
        edit(jsonData, area, jsonAccettazione = null) {
            let me = this;
            me.prescrizione = { quantitaAccessi: 0 };
            // console.log(jsonAccettazione);

            me.jsonDataAccettazione = jsonAccettazione;
            me.loadAttivita(area);
            me.$refs.mdlRsaAreaPianificazioneEdit.show();
            me.activeTabIndex = 0;
            if (jsonData.id) {
                me.loadData(jsonData.id);
            } else {
                me.setData(jsonData);
            }
            if (jsonAccettazione !== null) {
                this.setDisableTads(jsonAccettazione);
            }
        },
        setDisableTads(jsonAccettazione) {
            console.log(jsonAccettazione);
            if (jsonAccettazione.regime === "DOMICILIARE") {
                this.tabOrarioDisabled = true;
                this.tabTurniDisabled = true;
                this.tabOreAlternateDisabled = true;
                this.tabGiorniAlternatiDisabled = true;
                this.tabGiorniMeseDisabled = true;
                this.tabAccessiDisabled = false;
            } else {
                this.tabOrarioDisabled = false;
                this.tabTurniDisabled = false;
                this.tabOreAlternateDisabled = false;
                this.tabGiorniAlternatiDisabled = false;
                this.tabGiorniMeseDisabled = false;
                this.tabAccessiDisabled = true;
            }
        },
        loadData(id) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            axios
                .get(link)
                .then((response) => {
                    //me.jsonData = response.data.data;
                    me.setData(response.data.data);
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        setData(jsonData) {
            let me = this;
            //console.log("setData", jsonData);

            me.jsonData = jsonData;
            if (me.jsonData.idPrescrizione) {
                me.loadPrescrizione();
            }
            me.listaOrari = me.jsonData.listaOrari;
            if (me.listaOrari.length) {
                me.riepilogo.quantitaSchedulata = me.listaOrari.length;
            }
            if (me.listaOrari.length > 0) {
                me.pianificazione = me.listaOrari[0];
            }
        },
        disbilitaOrePrecedenti(date) {
            let me = this;
            let today = new Date();
            let dataRiferimento = new Date(me.schedulazione.dataInizio);
            if (dataRiferimento.getFullYear() === today.getFullYear() && dataRiferimento.getMonth() === today.getMonth() && dataRiferimento.getDate() === today.getDate()) {
                return date.getHours() < new Date().getHours();
            } else {
                return false;
            }
        },

        onOk(bvModalEvent) {
            let me = this;

            if (me.jsonData.id === null) {
                me.createSchedulazione();
            } else {
                me.updateSchedulazione();
            }
            bvModalEvent.preventDefault();
        },
        loadPrescrizione() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcesPrescrizioni + "/" + me.jsonData.idPrescrizione;
            axios
                .get(link)
                .then((response) => {
                    me.prescrizione = response.data.data;
                    me.riepilogo.quantitaProgrammata = me.prescrizione.quantitaAccessi;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        onInputSchedulazioneDataInizio() {
            let me = this;
            me.orarioData = me.schedulazione.dataInizio;
        },
        validaDati() {
            let me = this;
            let returnValue = true;
            if (this.jsonData.nomeAttivita === "SOMMINISTRAZIONE FARMACOLOGICA") {
                if (!this.jsonData.dettaglio) {
                    returnValue = false;
                    this.$bvToast.toast("Selezionare il nome del farmaco", {
                        title: "ATTENZIONE",
                        autoHideDelay: 5000,
                        variant: "danger",
                    });
                } else if (!this.jsonDataParams.dose) {
                    returnValue = false;
                    this.$bvToast.toast("La 'Dose' non è valida", {
                        title: "ATTENZIONE",
                        autoHideDelay: 5000,
                        variant: "danger",
                    });
                } else if (me.listaOrari.length > 0) {
                    returnValue = false;
                    let item = me.listaOrari[0];
                    let params = JSON.parse(item.params);
                    if (params.tipologia == "GiornoMese") {
                        console.log(item);
                        if (item.orari == "") {
                            this.$bvToast.toast("Indicare almeno un orario", {
                                title: "ATTENZIONE",
                                autoHideDelay: 5000,
                                variant: "danger",
                            });
                            this.$refs.mdlRsaAreaPianificazioneEdit.preventDefault();
                        }
                    }
                }
            }

            return returnValue;
        },
        createSchedulazione() {
            let me = this;
            let localPathResources = me.pathResource;
            let objectToSave = me.jsonData;

            if (me.jsonData.nomeAttivita === "SOMMINISTRAZIONE FARMACOLOGICA") {
                localPathResources = me.pathResourcePazientePrescrizioniFarmacologiche;
                let params = { listaOrari: me.listaOrari, schedulerParams: me.jsonDataParams };
                objectToSave = {
                    id: null,
                    idAccettazione: me.jsonData.idAccettazione,
                    idPaziente: me.jsonData.idPaziente,
                    tipoPrestazione: "FARMACOLOGICA",
                    dataInizio: me.jsonData.dataInizio,
                    dataFine: null,
                    codiceProdotto: me.schedaFarmaco.codiceProdotto,
                    atcGmp: me.schedaFarmaco.atcGmp,
                    prescrizione: me.jsonData.dettaglio,
                    quantita: 1,
                    frequenza: null,
                    costo: me.schedaFarmaco.euroPrezzo1,
                    stato: null,
                    note: null,
                    params: JSON.stringify(params),
                };
                return;
            } else {
                me.jsonData.listaOrari = me.listaOrari;
                me.jsonData.params = JSON.stringify(me.jsonDataParams);
                objectToSave = me.jsonData;
            }

            let link = process.env.VUE_APP_PATH_API + localPathResources;
            console.log(objectToSave);

            if (this.validaDati()) {
                axios
                    .post(link, objectToSave)
                    .then(() => {
                        me.$emit("afterSaveRequest");
                        me.$refs.mdlRsaAreaPianificazioneEdit.hide();
                    })
                    .catch((error) => {
                        me.$emit("afterSaveRequest");
                        let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                        me.$bvModal
                            .msgBoxOk(messaggio, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerBgVariant: "danger",
                                centered: true,
                            })
                            .then(() => { })
                            .catch((err) => {
                                console.log(err);
                            });
                    });
            }
        },
        updateSchedulazione() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.id;
            me.jsonData.listaOrari = me.listaOrari;
            delete me.jsonData.tipologia;
            delete me.jsonData.annotazione;
            delete me.jsonData.idRsaAttivitaPaziente;
            delete me.jsonData.dataOraEsecuzione;
            delete me.jsonData.dataOraProgrammata;
            delete me.jsonData.viaSomministrazione;
            delete me.jsonData.descrizioneAttivitaExtra;
            axios
                .put(link, JSON.stringify(me.jsonData))
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.$refs.mdlRsaAreaPianificazioneEdit.hide();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    toast.error(messaggio);
                });
        },
        onContext(ctx) {
            // console.log(ctx);
            let me = this;
            me.schedulazione.dataInizio = ctx.activeDate.getTime();
        },
        onClickAggiungiOrario() {
            let me = this;
            if (!me.schedulazione.dataInizio) {
                toast.error("Data Programmata Obbligatoria");
            } else if (!me.schedulazione.orario) {
                toast.error("Ora Programmata Obbligatoria")
            } else {
                let dataRiferimento = new Date(me.schedulazione.dataInizio);
                let oraRiferimento = new Date(me.schedulazione.orario);
                dataRiferimento.setHours(oraRiferimento.getHours(), oraRiferimento.getMinutes(), 0);
                let nuovoOrario = { dataInizio: me.schedulazione.dataInizio, orario: dataRiferimento.getTime() };
                me.listaOrari.push(nuovoOrario);
                me.riepilogo.quantitaSchedulata = me.listaOrari.length;
            }
        },
        loadAttivita(area) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAttivita;
            let tipologia = me.jsonDataAccettazione !== null && me.jsonDataAccettazione.regime === "DOMICILIARE" ? "DOMICILIARE" : "RESIDENZIALE";
            me.attivitaOptions = [];
            me.attivitaItems = [];
            me.$emit("beforeLoadData");
            axios
                .get(link, { params: { idArea: area.id, tipologia: tipologia } })
                .then((response) => {
                    me.attivitaItems = response.data.data.list;
                    me.attivitaItems.forEach((element) => {
                        me.attivitaOptions.push({ codice: element.nomeAttivita, nomeAttivita: element.nomeAttivita });
                    });
                    me.attivitaOptions.unshift({ codice: null, nomeAttivita: "-Seleziona Attività-" });
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onClickDelete(array, row) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Titolo",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        array.splice(row.index, 1);
                        me.riepilogo.quantitaProgrammata = me.listaOrari.length;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        checkDisableDelete() {
            // console.log(item.orario < Date.now());
            // return item.orario < Date.now();
            return false;
        },
        onAfterMountedRsaPianificazioneEditTurni() {
            // let me = this;
            // console.log(me.pianificazione);
            // me.$refs.cmpRsaPianificazioneEditTurni.setPianificazione(me.pianificazione);
        },
        onAfterMountedRsaPianificazioneEditOrario() { },
        onChangeAttivita(value) {
            let me = this;
            me.attivitaItems.forEach((element) => {
                if (element.nomeAttivita === value) {
                    me.jsonData.idForm = element.idForm;
                }
            });
        },
        onUpdatePianificazioneTurni(params) {
            this.listaOrari = [];
            this.listaOrari.push({ tipo: "TURNI", giorni: params.giorni, orari: params.orari, params: "{}" });
        },
        onUpdatePianificazioneOrario(params) {
            this.listaOrari = [];
            this.listaOrari.push({ tipo: "ORARIO", giorni: params.giorni, orari: params.orari, params: "{}" });
        },
        onAfterMountedRsaPianificazioneEditOreAlternate() { },
        onUpdatePianificazioneOreAlternate(params) {
            this.listaOrari = [];
            this.listaOrari.push({ tipo: "ORE ALTERNATE", giorni: params.giorni, orari: params.orari, params: JSON.stringify(params.params) });
        },
        onAfterMountedRsaPianificazioneEditGiorniAlternati() { },
        onUpdatePianificazioneGiorniAlternati(params) {
            this.listaOrari = [];
            this.listaOrari.push({ tipo: "GIORNI ALTERNATI", giorni: params.giorni, orari: params.orari, params: JSON.stringify(params.params) });
        },
        onAfterMountedRsaPianificazioneEditGiorniMese() { },
        onUpdatePianificazioneGiorniMese(params) {
            this.listaOrari = [];
            this.listaOrari.push({ tipo: "GIORNI MESE", giorni: params.giorni, orari: params.orari, params: JSON.stringify(params.params) });
        },
        onAfterMountedRsaPianificazioneEditAccessi() { },
        onUpdatePianificazioneAccessi(params) {
            this.listaOrari = [];
            console.log(params);
            this.listaOrari.push({ tipo: "ACCESSI", giorni: params.giorni, orari: "00:00", params: JSON.stringify(params.params) });
        },
        onShown() {
            let me = this;
            setTimeout(me.setPianificazione, 500);
        },
        setPianificazione() {
            let me = this;
            switch (me.pianificazione.tipo) {
                case "TURNI":
                    me.$refs.cmpRsaPianificazioneEditTurni.setPianificazione(me.pianificazione);
                    me.activeTabIndex = 1;
                    break;
                case "ORARIO":
                    me.$refs.cmpRsaPianificazioneEditOrario.setPianificazione(me.pianificazione);
                    me.activeTabIndex = 0;
                    break;
                case "ORE ALTERNATE":
                    me.$refs.cmpRsaPianificazioneEditOreAlternate.setPianificazione(me.pianificazione);
                    me.activeTabIndex = 2;
                    break;
                case "GIORNI ALTERNATI":
                    me.$refs.cmpRsaPianificazioneEditGiorniAlternati.setPianificazione(me.jsonData, me.pianificazione);
                    me.activeTabIndex = 3;
                    break;
                case "MESI ALTERNATI":
                    me.$refs.cmpRsaPianificazioneEditGiorniMese.setPianificazione(me.pianificazione);
                    me.activeTabIndex = 4;
                    break;
                case "GIORNI MESE":
                    me.$refs.cmpRsaPianificazioneEditGiorniMese.setPianificazione(me.pianificazione);
                    me.activeTabIndex = 4;
                    break;
                case "ACCESSI":
                    me.$refs.cmpRsaPianificazioneEditAccessi.setPianificazione(me.pianificazione);
                    me.activeTabIndex = 5;
                    break;
            }
        },
        onClickOpenRicercaFarmaco() {
            let me = this;
            //document.getElementById("boxSelezionaFarmaco").style.visibility = "visible";
            document.getElementById("boxSelezionaFarmaco").classList.remove("sa-bancafarmaci-hidden");
            document.getElementById("boxSelezionaFarmaco").classList.add("sa-bancafarmaci-visible");
            me.disabeConferma = true;
        },
        closeRicercaFarmaco() {
            let me = this;
            document.getElementById("boxSelezionaFarmaco").classList.remove("sa-bancafarmaci-visible");
            document.getElementById("boxSelezionaFarmaco").classList.add("sa-bancafarmaci-hidden");
            me.disabeConferma = false;
        },
        onConfermaSelezioneBancaFarmaciRicercaFarmacoComponent(schedaFarmaco) {
            this.schedaFarmaco = schedaFarmaco;
            this.jsonData.dettaglio = schedaFarmaco.descrizione;
            this.jsonDataParams.formaFarmaceutica = schedaFarmaco.formaFarmaceutica.descrizione;
            this.closeRicercaFarmaco();
        },
        onAnnullaSelezioneBancaFarmaciRicercaFarmacoComponent() {
            this.closeRicercaFarmaco();
        },
    },
};
/*
TOOLBAR STANDARD
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                ["link", "image", "video"],
                ["clean"], // remove formatting button
            ],

*/
</script>

<style scoped>
.sa-flexbox-body .row {
    flex: 1;
    height: 1px;
}

.sa-flexbox-body .row .col-sm-12.col-md-12.col-lg-12.col-xl-12.col-12 {
    height: 100%;
}

.sa-pianificazione-edit-container {
    padding: 10px;
}

.sa-pianificazione-edit-container-selector {
    background-color: #f4f4f4;
    line-height: 30px;
}
</style>
